const app = angular.module('msi.toasts', [
  'pascalprecht.translate',
  'ngSanitize',
  require('./container')
]);

app.service('toastService', require('./toast.service'));
app.component('ogToast', require('./toast'));

module.exports = app.name;
